<app-generic-header [goBack]="dismiss.bind(this)" variant="back">
</app-generic-header>

<ion-content class="ion-padding" *ngIf="!isNative">
    <div class="noVegglyStoreOnWeb">
        <p>{{'noVegglyStore' | translate}}</p>
    </div>
    <ion-button expand="block" class="button-edit-profile-share" shape="round" (click) = "downloadApp()">
        {{'downloadApp' | translate}}
    </ion-button>  
</ion-content>

<ion-content class="ion-padding" *ngIf="isNative">
    <div class="storeContainer">
        <!--===| Premium Or Avocado Club |===-->
        <div class="premiumStore">

            <div class="background{{showingAdvantage ? ' blurred' : ''}}">

                <div class="topicLogo">
                    <img class="topicLogoMain" src="./assets/imgs/fyraplus.svg">
                </div>

                <div class="topText">
                    <h1 class="titlePage avocadoTitle">
                        {{'avocadoClub' | translate}}
                        <div class="topicOwnedText">
                            {{(getExpirationDateExists() && getExpirationDate()) ? (('memberUntil' | translate) + ' ' + getExpirationDate()) : ''}}
                        </div>
                    </h1>

                    <div>
                        <div class="advantageText">
                            <swiper-container #swiper [initialSlide]="slideOpts.initialSlide" autoplay="true" pagination="true" [loop]="true">
                                <swiper-slide>
                                    <ion-item lines="none">
                                        <ion-thumbnail item-start>
                                            <ion-icon name="heart" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>{{'seeWhoLikedYou' | translate}}</h2>
                                            <div>
                                                <h3>{{'getVegMatchesInstantly' | translate}}</h3>
                                            </div>

                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none">
                                        <ion-thumbnail item-start>
                                            <ion-icon name="arrow-up" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>{{'moreLikes' | translate}}</h2>
                                            <div style="padding-right: 13%;">
                                                <h3>{{'getYourProfileInFrontOfMorePeople' | translate}}</h3>
                                            </div>
                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none" text-wrap>
                                        <ion-thumbnail item-start>
                                            <ion-icon name="close-circle" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>{{'noAds' | translate}}</h2>
                                            <div style="padding-right: 15%;">
                                                <h3>{{'DontBeInterruptedWhileEnjoyingVeggly' | translate}}</h3>
                                            </div>

                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none" text-wrap>
                                        <ion-thumbnail item-start>
                                            <ion-icon name="flame" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>3 {{'vegglyCoins' | translate}} {{'perMonth' | translate}}</h2>
                                            <div style="padding-right: 15%;">
                                                <h3>{{'Enjoy3CarrotsEveryMonth' | translate}}</h3>
                                            </div>

                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none" text-wrap>
                                        <ion-thumbnail item-start>
                                            <ion-icon name="location" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>{{'teleportation' | translate}}</h2>
                                            <h3>{{'meetPeopleAnywhere' | translate}}</h3>
                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none" text-wrap>
                                        <ion-thumbnail item-start>
                                            <ion-icon name="checkmark-circle" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>{{'chatReadConfirmation' | translate}}</h2>
                                            <div style="padding-right: 13%;">
                                                <h3>{{'knowVegMatchHasReadMessage' | translate}}</h3>
                                            </div>

                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none" text-wrap>
                                        <ion-thumbnail item-start>
                                            <ion-icon name="star" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <div style="margin-right:10%">
                                                <h2>{{'avocadoClubMemberIndicator' | translate}}</h2>
                                            </div>

                                            <div style="padding-right: 5%;">
                                                <h3>{{'showProfileIsMemberAvocadoClub' | translate}}</h3>
                                            </div>

                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                                <swiper-slide>
                                    <ion-item lines="none" text-wrap>
                                        <ion-thumbnail item-start>
                                            <ion-icon name="thumbs-up" class="advantage-icon"></ion-icon>
                                        </ion-thumbnail>
                                        <ion-label>
                                            <h2>{{'goodKarma' | translate}}</h2>
                                            <h3 text-wrap>{{'forHelpingVegglyGrow' | translate}}</h3>
                                        </ion-label>
                                    </ion-item>
                                </swiper-slide>
                            </swiper-container>

                        </div>
                    </div>
                </div>

                <div class="storeOptions">
                    <ion-row class="packageOptionsContainer">
                        <ion-col size="4">
                            <div class="packageOption {{selection[3]}}" (click)="optionClicked(3)">
                                <div class="packageAmountContainer">
                                    <span class="packageQtd subscriptionQty"> 12 </span> <span
                                        class="monthOption">{{'upperMonths' | translate}}</span>
                                </div>
                                <ng-container *ngIf="isPriceLoaded(12, 'club'); else loading12">
                                    <div class="packageDescriptionContainer avocadoPackageDescription">
                                        <div *ngIf="!userData?.config?.showTotalPrice">
                                            <p class="packageDescriptionPrice avocadoPackageDescription priceString">
                                                {{getProductCurrency()}} {{formatMicro(getPricesNumberMicro(12, 'club'), 12)}} / {{'month' | translate}}
                                            </p>
                                            <p *ngIf="!platform.is('android')" class="packageDescriptionEach avocadoPackageDescription">
                                                {{getPricesString(12, 'club')}}
                                            </p>
                                        </div>
                                        <p *ngIf="userData?.config?.showTotalPrice" class="packageDescriptionPrice avocadoPackageDescription priceString">
                                            {{getPricesString(12, 'club')}}
                                        </p>
                                        <p *ngIf="userData?.config?.showTotalPrice" class="packageDescriptionEach avocadoPackageDescription">
                                            {{getProductCurrency()}} {{formatMicro(getPricesNumberMicro(12, 'club'), 12)}} / {{'month' | translate}}
                                        </p>
                                        <span class="discountBubble">
                                            <div class="discountContainer">
                                                <p class="discountAmount">
                                                    {{'saveMoney' | translate}}
                                                    {{formatNoDecimal(purchaseServiceProvider.club_12_monthsDiscount)}}%
                                                </p>
                                            </div>
                                        </span>
                                        <p class="packageDescriptionAmount">&nbsp;</p>
                                    </div>
                                </ng-container>
                                <ng-template #loading12>
                                    <div class="packageDescriptionContainer avocadoPackageDescription">
                                        <div class="animationContainer">
                                            <p class="packageDescriptionAmount shimmerBG loading amount">&nbsp;</p>
                                        </div>
                                        <br>
                                        <p class="packageDescriptionAmount">&nbsp;</p>
                                    </div>
                                </ng-template>
                            </div>
                        </ion-col>
                        <!-- <ion-col size="4" *ngIf="this.isTestAbForAndroid || !this.platform.is('android')"></ion-col> -->
                        <ion-col size="4">
                            <div class="packageOption {{selection[1]}}" (click)="optionClicked(1)">
                                <span class="more-populate">
                                    {{'morePopulate' | translate}}
                                </span>

                                <div class="packageAmountContainer">
                                    <span class="packageQtd subscriptionQty"> 3 </span> <span
                                        class="monthOption">{{'upperMonths' | translate}}</span>
                                </div>
                                <ng-container *ngIf="isPriceLoaded(3, 'club'); else loading3">
                                    <div class="packageDescriptionContainer avocadoPackageDescription">
                                        <div *ngIf="!userData?.config?.showTotalPrice">
                                            <p class="packageDescriptionPrice avocadoPackageDescription priceString">
                                                {{getProductCurrency()}} {{formatMicro(getPricesNumberMicro(3, 'club'), 3)}} / {{'month' | translate}}
                                            </p>
                                            <p *ngIf="!platform.is('android')" class="packageDescriptionEach avocadoPackageDescription">
                                                {{getPricesString(3, 'club')}}
                                            </p>
                                        </div>
                                        <p *ngIf="userData?.config?.showTotalPrice" class="packageDescriptionPrice avocadoPackageDescription priceString">
                                            {{getPricesString(3, 'club')}}
                                        </p>
                                        <p *ngIf="userData?.config?.showTotalPrice" class="packageDescriptionEach avocadoPackageDescription">
                                            {{getProductCurrency()}} {{formatMicro(getPricesNumberMicro(3, 'club'), 3)}} / {{'month' | translate}}
                                        </p>
                                        <span class="discountBubble">
                                            <div class="discountContainer">
                                                <p class="discountAmount">
                                                    {{'saveMoney' | translate}}
                                                    {{formatNoDecimal(purchaseServiceProvider.club_3_monthsDiscount)}}%
                                                </p>
                                            </div>
                                        </span>
                                        <p class="packageDescriptionAmount">&nbsp;</p>
                                    </div>
                                </ng-container>
                                <ng-template #loading3>
                                    <div class="packageDescriptionContainer avocadoPackageDescription">
                                        <div class="animationContainer">
                                            <p class="packageDescriptionAmount shimmerBG loading amount">&nbsp;</p>
                                        </div>
                                        <br>
                                        <p class="packageDescriptionAmount">&nbsp;</p>
                                    </div>
                                </ng-template>
                            </div>
                        </ion-col>
                        <!-- <ion-col size="4" *ngIf="!this.isTestAbForAndroid && this.platform.is('android')">
                          <div class="packageOption {{selection[2]}}" (click)="optionClicked(2)">
                              <span class="more-populate">
                                  {{'morePopulate' | translate}}
                              </span>

                              <div class="packageAmountContainer">
                                  <span class="packageQtd subscriptionQty"> 6 </span> <span
                                      class="monthOption">{{'upperMonths' | translate}}</span>
                              </div>

                              <br *ngIf="!isPriceLoaded(6, 'club')">

                              <div class="packageDescriptionContainer avocadoPackageDescription">


                                  <div *ngIf="!this.userData?.config?.showTotalPrice">
                                      <p *ngIf="isPriceLoaded(6, 'club')"
                                          class="packageDescriptionPrice avocadoPackageDescription priceString">
                                          {{isPriceLoaded(6, 'club') ? getProductCurrency() + " " +
                                          formatMicro(getPricesNumberMicro(6,
                                          'club'), 6) + " / " + ('month' | translate) : ""}}
                                      </p>
                                      <p *ngIf="isPriceLoaded(6, 'club') && !this.platform.is('android')"
                                          class="packageDescriptionEach avocadoPackageDescription">
                                          {{isPriceLoaded(6,
                                          'club') ? getPricesString(6,
                                          'club') : '...'}}
                                      </p>
                                  </div>

                                  <p *ngIf="isPriceLoaded(6, 'club') && this.userData?.config?.showTotalPrice"
                                      class="packageDescriptionPrice avocadoPackageDescription priceString">
                                      {{isPriceLoaded(6,
                                      'club') ? getPricesString(6,
                                      'club') : '...'}}
                                  </p>
                                  <p *ngIf="isPriceLoaded(6, 'club') && this.userData?.config?.showTotalPrice"
                                      class="packageDescriptionEach avocadoPackageDescription">
                                      {{isPriceLoaded(6, 'club') ? getProductCurrency() + " " +
                                      formatMicro(getPricesNumberMicro(6,
                                      'club'), 6) + " / " + ('month' | translate) : ""}}
                                  </p>

                                  <span class="discountBubble" *ngIf="isPriceLoaded(6, 'club')">

                                      <div class="discountContainer">
                                        
                                          <p class="discountAmount">
                                              {{'saveMoney' | translate}}
                                              {{formatNoDecimal(purchaseServiceProvider.club_6_monthsDiscount)}}%
                                          </p>



                                      </div>
                                  </span>

                                  <div *ngIf="!isPriceLoaded(6, 'club')" class="animationContainer">
                                      <p
                                          class="packageDescriptionAmount{{isPriceLoaded(6, 'club') ? '' : ' shimmerBG loading amount'}}">
                                          &nbsp;
                                      </p>
                                  </div>

                                  <br *ngIf="!isPriceLoaded(6, 'club')">

                                  <p *ngIf="isPriceLoaded(6, 'club')" class="packageDescriptionAmount">
                                      &nbsp;
                                  </p>
                              </div>
                          </div>
                      </ion-col> -->
                        <ion-col size="4">
                            <div class="packageOption {{selection[0]}}" (click)="optionClicked(0)">
                                <div class="packageAmountContainer">
                                    <span class="packageQtd subscriptionQty"> 1 </span> <span
                                        class="monthOption">{{'upperMonth' | translate}}</span>
                                </div>
                                <ng-container *ngIf="isPriceLoaded(1, 'club'); else loading1">
                                    <div class="packageDescriptionContainer avocadoPackageDescription">
                                        <div *ngIf="!userData?.config?.showTotalPrice">
                                            <p class="packageDescriptionPrice avocadoPackageDescription priceString">
                                                {{getProductCurrency()}} {{formatMicro(getPricesNumberMicro(1, 'club'), 1)}}
                                            </p>
                                            <p *ngIf="!platform.is('android')" class="packageDescriptionEach avocadoPackageDescription">
                                                {{getPricesString(1, 'club')}}
                                            </p>
                                        </div>
                                        <p *ngIf="userData?.config?.showTotalPrice" class="packageDescriptionPrice avocadoPackageDescription priceString">
                                            {{getPricesString(1, 'club')}}
                                        </p>
                                        <p class="packageDescriptionAmount">&nbsp;</p>
                                    </div>
                                </ng-container>
                                <ng-template #loading1>
                                    <div class="packageDescriptionContainer avocadoPackageDescription">
                                        <div class="animationContainer">
                                            <p class="packageDescriptionAmount shimmerBG loading amount">&nbsp;</p>
                                        </div>
                                        <br>
                                        <p class="packageDescriptionAmount">&nbsp;</p>
                                    </div>
                                </ng-template>
                            </div>
                        </ion-col>
                    </ion-row>

                </div>
            </div>
        </div>
        <!--===| // |===-->

        <div class="foreground{{showingAdvantage ? ' clear' : ''}}">
            <div *ngIf="showingAdvantage" class="advantageContainerAvocadoclub">
                <div class="backArrowSection advantage">
                    <ion-button fill="clear" (click)="dismissModal()">
                        <label>
                            < </label>
                    </ion-button>
                </div>

                <div class="advantagesModalBox">

                    <div class="imgDiv">
                        <img class="avocadoLogo" src="assets/imgs/fyraplus.svg" alt="Avocadoclub">
                    </div>

                    <div class="advantageTopTextContainer">
                        <span class="advantageTitle">{{'avocadoClub' | translate}}</span><br>
                    </div>

                    <ul class="advantagesList">
                        <li>{{'seeWhoLikedYou' | translate}}</li>
                        <li>{{'noAds' | translate}}</li>
                        <li>3 {{'vegglyCoins' | translate}} {{'perMonth' | translate}}</li>
                        <li>{{'teleportation' | translate}}</li>
                        <li>{{'chatReadConfirmation' | translate}}</li>
                        <li>{{'avocadoClubMemberIndicator' | translate}}</li>
                        <li>{{'goodKarmaForHelpingVegglyGrow' | translate}}</li>
                    </ul>

                    <ion-button class="purchaseButton" (click)="dismissModal()">
                        {{('join' | translate)}}
                    </ion-button>

                </div>
            </div>
        </div>


        <div class="footerButtons{{showingAdvantage ? ' blurred' : ''}}">

            <ion-button shape="round" class="purchaseButton" (click)="buy()">
                {{getBuyButtonText()}}
            </ion-button>

            <div class="bottomText subscriptionText">
                <span (click)="openLinkPlayStore()" *ngIf="this.platform.is('android')">
                    <span [innerHTML]="'subscriptionExplanationForAndroid' | translate"></span>
                </span>
                <span *ngIf="!this.platform.is('android')">
                    {{('subscriptionExplanation' | translate)}}
                </span>
            </div>

            <div *ngIf="this.showContinueWithoutJoining">
                <ion-button (click)="dismiss()" class="continueWhithoutJoiningButton"
                    fill="clear">{{'continueWithoutJoining' | translate}}</ion-button>
            </div>

            <div class="restorePurchasesLink">
                <a (click)="restorePurchases()">{{'restorePurchases' | translate}}</a>
            </div>
        </div>
    </div>

</ion-content>